import _defineProperty from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import request from '@/utils/request';
export function saveWoermaCouponCategory(data) {
  return request({
    url: '/orders/channel-profig-rate-config/save-woerma-channel-category',
    method: 'post',
    data: data
  });
}
export function saveDrfSmgCompanyCodeConfigCustomer(data) {
  return request({
    url: '/customer/customer-account-new/save-drf-smg-company-code-config',
    method: 'post',
    data: data
  });
}

// 客户列表 - 设置 - 专属链接 - 列表
export function getUrlList(params) {
  return request({
    url: '/customer/customer-account-new/get-url-list',
    method: 'get',
    params: params
  });
}
// 客户列表 - 设置 - 专属链接 - 查看
export function getUrlDetail(params) {
  return request({
    url: '/customer/customer-account-new/get-url-detail',
    method: 'get',
    params: params
  });
}
// 客户列表 - 设置 - 专属链接 - 默认名称
export function getUrlDefaultName(params) {
  return request({
    url: '/customer/customer-account-new/get-url-default-name',
    method: 'get',
    params: params
  });
}
// 客户列表 - 设置 - 专属链接 - 添加
export function addUrl(data) {
  return request({
    url: '/customer/customer-account-new/add-url',
    method: 'post',
    data: data
  });
}
// 客户列表 - 设置 - 专属链接 - 更新
export function editUrl(data) {
  return request({
    url: '/customer/customer-account-new/edit-url',
    method: 'post',
    data: data
  });
}
// 客户列表 - 设置 - 专属链接 - 启用前判断
export function enableUrlJudge(data) {
  return request({
    url: '/customer/customer-account-new/enable-url-judge',
    method: 'post',
    data: data
  });
}
// 客户列表 - 设置 - 专属链接 - 启用禁用
export function enableUrl(data) {
  return request({
    url: '/customer/customer-account-new/enable-url',
    method: 'post',
    data: data
  });
}
// 客户列表 - 设置 - 专属链接 - 操作权限
export function urlOperateAuth(params) {
  return request({
    url: '/customer/customer-account-new/url-operate-auth',
    method: 'get',
    params: params
  });
}
// 客户列表 - 设置 - 专属链接 - 操作日志
export function getLinkLogList(params) {
  return request({
    url: '/customer/customer-account-new/get-log-list',
    method: 'get',
    params: params
  });
}

// 获取供应商列表
export function getCustomerList(data) {
  return request({
    url: '/orders/customer/list',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 查看
export function getCustomerInfo(data) {
  return request({
    url: '/orders/customer/info',
    method: 'post',
    data: data
  });
}
export function getCustomerActivityList(params) {
  return request({
    url: '/orders/customer/activity-list',
    method: 'get',
    params: params
  });
}
// 发票列表
export function getInvoiceList(data) {
  var params = _objectSpread({}, data);
  // 兼容逻辑：如果没有传pagesize，则添加默认参数
  if (!params.pagesize) {
    params.page = 1;
    params.pagesize = 9999;
  }
  return request({
    url: '/orders/customer/invoice-list',
    method: 'post',
    data: params
  });
}
// 创建发票
export function createInvoice(data) {
  return request({
    url: '/orders/customer-invoice-account/create',
    method: 'post',
    data: data
  });
}
// 修改发票
export function editInvoice(data) {
  return request({
    url: '/orders/customer-invoice-account/update',
    method: 'put',
    data: data
  });
}

// 设为默认
export function setDefault(data) {
  return request({
    url: '/orders/customer-invoice-account/set-default',
    method: 'post',
    data: data
  });
}

// 创建客户
export function createCustomer(data) {
  return request({
    url: '/orders/customer/create',
    method: 'post',
    data: data
  });
}
// 编辑客户
export function editCustomer(data) {
  return request({
    url: '/orders/customer/update',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业详情
 * @param {*} data
 * @returns
 */
export function getCustomerAccountInfo(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-info',
    method: 'get',
    params: params
  });
}
/**
 * 设置客户企业详情保存
 * @param {*} data
 * @returns
 */
export function saveCustomerAccountInfo(data) {
  return request({
    url: '/customer/customer-account-new/save-customer-account-info',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业个人中心
 * @param {*} data
 * @returns
 */
export function getCustomerAccountCenter(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-center',
    method: 'get',
    params: params
  });
}
/**
 * 设置客户企业个人中心配置保存
 * @param {*} data
 * @returns
 */
export function saveCustomerAccountCenter(data) {
  return request({
    url: '/customer/customer-account-new/save-customer-account-center',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户图片配置
 * @param {*} data
 * @returns
 */
export function getCustomerAccountImage(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-image',
    method: 'get',
    params: params
  });
}
/**
 * 设置客户企业图片
 * @param {*} data
 * @returns
 */
export function saveCustomerAccountImage(data) {
  return request({
    url: '/customer/customer-account-new/save-customer-account-image',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业图库图片
 * @param {*} data
 * @returns
 */
export function getgalleryList(params) {
  return request({
    url: '/mapdepot/map-depot-type/index-img',
    method: 'get',
    params: params
  });
}
/**
 * 获取客户企业高级设置
 * @param {*} data
 * @returns
 */
export function getCustomerAccountExtend(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-extend',
    method: 'get',
    params: params
  });
}
/**
 * 高级设置保存
 * @param {*} data
 * @returns
 */
export function saveCustomerAccountExtend(data) {
  return request({
    url: '/customer/customer-account-new/save-customer-account-extend',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业营销参数
 * @param {*} data
 * @returns
 */
export function getCustomerAccountMarketing(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-marketing',
    method: 'get',
    params: params
  });
}
/**
 * 不出票手机号黑名单列表
 * @param {*} params
 * @returns
 */
export function getMobileBlackList(params) {
  return request({
    url: '/customer/customer-account-new/mobile-black-list',
    method: 'get',
    params: params
  });
}
/**
 * 保存不出票手机号黑名单
 * @param {*} data
 * @returns
 */
export function setMobileBlackList(data) {
  return request({
    url: '/customer/customer-account-new/set-mobile-black-list',
    method: 'post',
    data: data
  });
}
/**
 * 企业营销参数保存
 * @param {*} data
 * @returns
 */
export function saveCustomerAccountMarketing(data) {
  return request({
    url: '/customer/customer-account-new/save-customer-account-marketing',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业影片列表
 * @param {*} data
 * @returns
 */
export function getMoviesList(params) {
  return request({
    url: '/customer/customer-account-new/get-movies-list',
    method: 'get',
    params: params
  });
}
/**
 * 设置客户企业影片黑名单
 * @param {*} data
 * @returns
 */
export function setBlackMovies(data) {
  return request({
    url: '/customer/customer-account-new/set-black-movies',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业
 * @param {*} data
 * @returns
 */
export function getCustomerAccountOne(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-account-one',
    method: 'get',
    params: params
  });
}

/**
 * 删除客户
 * @param {*} data
 * @returns
 */
export function delCustomer(data) {
  return request({
    url: '/orders/customer/del',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业影院列表
 * @param {*} data
 * @returns
 */
export function getCinemaList(params) {
  return request({
    url: '/customer/customer-account-new/get-cinema-list',
    method: 'get',
    params: params
  });
}
/**
 * 设置客户企业影院黑名单
 * @param {*} data
 * @returns
 */
export function setBlackCinema(data) {
  return request({
    url: '/customer/customer-account-new/set-black-cinema',
    method: 'post',
    data: data
  });
}
/**
 * 获取客户企业操作日志-搜索项
 * @param {*} data
 * @returns
 */
export function getCustomerLogSearch(params) {
  return request({
    url: '/customer/customer-account-new/get-customer-log-search',
    method: 'get',
    params: params
  });
}
/**
 * 获取客户企业操作日志
 * @param {*} data
 * @returns
 */
export function channelCustomerLogList(params) {
  return request({
    url: '/customer/customer-account-new/channel-customer-log-list',
    method: 'get',
    params: params
  });
}
export function getAddUsername(data) {
  return request({
    url: '/orders/customer/get-add-username',
    method: 'post',
    data: data
  });
}
// 获取企业账号登陆saas链接
export function getSassUrl(params) {
  return request({
    url: '/customer/customer-account-new/saas-login',
    method: 'get',
    params: params
  });
}
export function delRecovery(data) {
  return request({
    url: '/orders/customer/restore',
    method: 'post',
    data: data
  });
}

//获取客户风控
export function getCustomerRiskConfig(params) {
  return request({
    url: '/orders/order-risk-config/get-customer-config',
    method: 'get',
    params: params
  });
}
//获取客户消费风控预警
export function getCustomerConsumeRemind(params) {
  return request({
    url: '/orders/order-consume-remind-config/get-customer',
    method: 'get',
    params: params
  });
}
//客户设置风控级别
export function customerSetRiskConfig(data) {
  return request({
    url: '/orders/order-risk-config/customer-set-config',
    method: 'post',
    data: data
  });
}
//客户设置风控预警
export function customerSetconsumeConfig(data) {
  return request({
    url: '/orders/order-consume-remind-config/set-customer',
    method: 'post',
    data: data
  });
}
// 全渠道客户展示日志
export function platChannelCustomerLogList(params) {
  return request({
    url: '/plat/customer-account-new/channel-customer-log-list',
    method: 'get',
    params: params
  });
}
// 专属链接
export function getUrl(params) {
  return request({
    url: '/customer/customer-account-new/get-url',
    method: 'get',
    params: params
  });
}
// 在线点单增加个性化品牌
export function getCustomerOnlineFoodsBrandList(params) {
  return request({
    url: '/customer/customer-account-new//online-foods-brand-list',
    method: 'get',
    params: params
  });
}
// 在线点单 保存品牌
export function saveCustomerOnlineFoodsBrand(data) {
  return request({
    url: '/customer/customer-account-new/online-foods-rate-save',
    method: 'post',
    data: data
  });
}
// 在线点单 删除品牌
export function delCustomerOnlineFoodsBrand(data) {
  return request({
    url: '/customer/customer-account-new/online-foods-rate-del',
    method: 'post',
    data: data
  });
}
// 在线点单查看个性化品牌
export function getChannelCustomerOnlineFoodsBrandList(params) {
  return request({
    url: '/customer/customer-account-new/get-channel-rate-by-type',
    method: 'get',
    params: params
  });
}
// 获取交付方式
export function getDeliveryMethod(params) {
  return request({
    url: '/customer/customer-account-new/delivery-method',
    method: 'get',
    params: params
  });
}
// 提交交付方式
export function saveDeliveryMethod(data) {
  return request({
    url: '/customer/customer-account-new/delivery-method',
    method: 'post',
    data: data
  });
}
// 查看企业名称
export function getCustomerCompanyName(params) {
  return request({
    url: '/orders/customer/get-company-name',
    method: 'get',
    params: params
  });
}
// 查看集团名称
export function getCustomerGroupName(params) {
  return request({
    url: '/orders/customer/get-group-name',
    method: 'get',
    params: params
  });
}
export function customerFsSelect(params) {
  return request({
    url: '/orders/customer/fs-select',
    method: 'get',
    params: params
  });
}
// 获取一级客户标签
export function getCustomerOneTag(params) {
  return request({
    url: '/orders/customer-tag/one-tag',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 获取二级客户标签
export function getCustomerTwoTag(data) {
  return request({
    url: '/orders/customer-tag/two-tag',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 获取行业接口
export function getIndustryList(params) {
  return request({
    url: '/orders/customer/get-industry-list',
    method: 'get',
    params: params
  });
}
export function getHighSeas(params) {
  return request({
    url: '/orders/customer/get-high-seas',
    method: 'get',
    params: params
  });
}
// 获取纷享城市列表
export function fxCityList(params) {
  return request({
    url: '/orders/customer/fx-city-list',
    method: 'get',
    params: params
  });
}
// 获取纷享集团户列表
export function fsGroupList(params) {
  return request({
    url: '/orders/customer/fs-group-list',
    method: 'get',
    params: params
  });
}

/**
 * 主动识别tab
 * @param {*} params
 * @param {*} method
 * @returns
 */
export function loadIdentify(params) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return request(_defineProperty({
    url: '/customer/customer-account-new/identify',
    method: method
  }, method === 'get' ? 'params' : 'data', params));
}
//客户获取订单配置
export function getOrderConfigInfo(data) {
  return request({
    url: '/orders/add-order-config/get-customer-config',
    method: 'post',
    data: data
  });
}
//客户设置订单配置
export function setOrderConfigInfo(data) {
  return request({
    url: '/orders/add-order-config/set-customer-config',
    method: 'post',
    data: data
  });
}
// 客户菜单调价规则
export function getMenusAdjustRuleList(params) {
  return request({
    url: '/customer/customer-account-new/menus-adjust-rule',
    method: 'get',
    params: params
  });
}
// 客户菜单调价规则
export function getGoodsAdjustRuleList(params) {
  return request({
    url: '/customer/customer-account-new/goods-adjust-rule',
    method: 'get',
    params: params
  });
}
// 专属菜单
export function getExclusiveMenusList(params) {
  return request({
    url: '/customer/customer-account-new/get-exclusive-menu',
    method: 'get',
    params: params
  });
}
// 卡规则菜单
export function getCardRuleMenusList(params) {
  return request({
    url: '/customer/customer-account-new/get-card-rule-menu',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 个性化装修菜单
export function getCustomizedMenusList(params) {
  return request({
    url: '/customer/customer-account-new/get-customized-menu',
    method: 'get',
    params: params
  });
}
// 卡规则菜单 - 查看
export function watchMenuOrder(params) {
  return request({
    url: '/customer/customer-account-new/menu-order',
    method: 'get',
    params: params
  });
}
// 客户管理 设置 查看公司名
export function watchCompanyName(params) {
  return request({
    url: '/orders/customer/get-company-name',
    method: 'get',
    params: params
  });
}
/**
 * 客户管理 - 客户列表 - 设置 - 营销参数管理 蛋糕自由兑拉黑｜取消拉黑
 * @param {*} data
 * @returns
 */
export function setBlackCakeCustomer(data) {
  return request({
    url: '/orders/card-rule-extend/set-customer-extend',
    method: 'post',
    data: data
  });
}
// 客户管理 设置 用户管理-查询
export function getShopUser(params) {
  return request({
    url: '/customer/customer-account-new/get-shop-user',
    method: 'get',
    params: params
  });
}
// 客户管理 设置 用户管理-导出
export function getShopUserExport(params) {
  return request({
    url: '/customer/customer-account-new/get-shop-user-export',
    method: 'get',
    params: params
  });
}

// 客户管理 设置 用户管理-按条件清除登录状态
export function customerSignOut(params) {
  return request({
    url: '/customer/customer-account-new/sign-out',
    method: 'get',
    params: params
  });
}
// 客户管理 设置 用户管理-客服及售后工单配置
export function customerAfterSalesConfig(params) {
  return request({
    url: '/customer/customer-account-new/customer-after-sales-config',
    method: 'get',
    params: params
  });
}
export function saveCustomerAfterSalesConfig(data, params) {
  return request({
    url: '/customer/customer-account-new/customer-after-sales-config',
    method: 'post',
    data: data,
    params: params
  });
}
export function updateCustomerKeyword(data, params) {
  return request({
    url: '/customer/customer-account-new/save-supermarket-keyword-filter',
    method: 'post',
    data: data,
    params: params
  });
}
export function getCustomerRechargeConfig(params) {
  return request({
    url: '/customer/customer-account-new/recharge-config',
    method: 'get',
    params: params
  });
}
export function updateCustomerRechargeConfig(data, params) {
  return request({
    url: '/customer/customer-account-new/recharge-config',
    method: 'post',
    data: data,
    params: params
  });
}
export function getRechargeOrders(params) {
  return request({
    url: '/customer/customer-account-new/get-recharge-orders',
    method: 'get',
    params: params
  });
}
export function getIntegralExchangeConfig(params) {
  return request({
    url: '/customer/customer-account-new/integral-exchange-config',
    method: 'get',
    params: params
  });
}
export function updateIntegralExchangeConfig(data, params) {
  return request({
    url: '/customer/customer-account-new/integral-exchange-config',
    method: 'post',
    data: data,
    params: params
  });
}
export function getRechargeList(params) {
  return request({
    url: '/customer/customer-account-new/recharge-list',
    method: 'get',
    params: params
  });
}
export function editRecharge(data, params) {
  return request({
    url: '/customer/customer-account-new/edit-recharge',
    method: 'post',
    data: data,
    params: params
  });
}
export function addRecharge(data, params) {
  return request({
    url: '/customer/customer-account-new/recharge',
    method: 'post',
    data: data,
    params: params
  });
}